module.exports = __webpack_public_path__ + "60062620a387731522e849f3f3e41b55.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/protherm.png
 ** module id = 192
 ** module chunks = 0
 **/